import { tsPlugin } from './tsPlugin.js'

export = tsPlugin
